import React from "react";
import Top from "./Top/Top";

const TopPage = () => {
  return <Top />;
};

export default TopPage;
